import DomFactory from './factory';

export type TextAreaArgs = {
  value?: string;
  placeholder?: string;
};
export default class TextAreaDomFactory extends DomFactory {
  public createWrapper() {
    const quizContainer = document.createElement('div');
    quizContainer.classList.add('textarea-container');
    return quizContainer;
  }
  public createTextArea({ placeholder, value }: TextAreaArgs) {
    const alternativeItem = document.createElement('textarea');
    alternativeItem.classList.add('textarea-input');
    alternativeItem.placeholder = placeholder || '';
    value && (alternativeItem.value = value);
    return alternativeItem;
  }

  public createLabel(text: string) {
    const alternativeLetter = document.createElement('label');
    alternativeLetter.textContent = text;
    alternativeLetter.classList.add('textarea-label');
    return alternativeLetter;
  }

  public createMessageError(error: string) {
    const divElement = document.createElement('p');
    divElement.classList.add('textarea-error-message');
    divElement.innerHTML = error;
    return divElement;
  }
}
